"use strict";

module.exports = function () {
  return JSON.stringify(this.customQueries);
};


// WEBPACK FOOTER //
// ./src/components/vuetable-2-kernel/compiled/computed/custom-q.js